// Knopf „Mit Microsoft 365 anmelden“ auf der Anmeldeseite (encry_erp.sso.anmeldung, Spec Teilzahlung und SSO Abschnitt 2).
// Läuft auf jeder Website-Seite (web_include_js), handelt nur auf /login und nur, wenn der Server SSO als aktiv meldet
// (öffentliche Methode aktiv; ohne gültige Konfiguration False, dann bleibt die Seite wie sie ist). Das Ziel nach der Anmeldung
// kommt aus redirect-to der Anmeldeseite; der Server lässt nur relative Pfade zu.

(() => {
	if (window.location.pathname !== "/login") return;
	const METHODE = "/api/method/encry_erp.sso.anmeldung";

	const knopf = () => {
		if (document.querySelector(".encry-sso-login")) return;
		const ziel = new URLSearchParams(window.location.search).get("redirect-to") || "";
		const link = document.createElement("a");
		link.className = "es-button w-full btn-login-option encry-sso-login";
		link.href = `${METHODE}.anmelden${ziel ? `?redirect_to=${encodeURIComponent(ziel)}` : ""}`;
		link.textContent = "Mit Microsoft 365 anmelden";
		const ort = document.querySelector(".for-login .page-card-actions") || document.querySelector(".page-card-actions");
		if (ort) ort.appendChild(link);
	};

	fetch(`${METHODE}.aktiv`, { headers: { Accept: "application/json" }, credentials: "same-origin" })
		.then((antwort) => (antwort.ok ? antwort.json() : null))
		.then((daten) => {
			if (daten?.message !== true) return;
			if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", knopf);
			else knopf();
		})
		.catch(() => {}); // ohne Antwort kein Knopf, die Anmeldung mit Passwort bleibt
})();
